'use strict';
import * as $j_app$002edata$002e$002dDocument$002dReference from "./app.data.-Document-Reference.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_DocumentReferenceWithVersion$$anon$4() {
}
export { $c_Lapp_data_DocumentReferenceWithVersion$$anon$4 as $c_Lapp_data_DocumentReferenceWithVersion$$anon$4 };
$p = $c_Lapp_data_DocumentReferenceWithVersion$$anon$4.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_DocumentReferenceWithVersion$$anon$4;
/** @constructor */
function $h_Lapp_data_DocumentReferenceWithVersion$$anon$4() {
}
export { $h_Lapp_data_DocumentReferenceWithVersion$$anon$4 as $h_Lapp_data_DocumentReferenceWithVersion$$anon$4 };
$h_Lapp_data_DocumentReferenceWithVersion$$anon$4.prototype = $p;
$p.bwP = (function(src) {
  return new $j_app$002edata$002e$002dDocument$002dReference.$c_Lapp_data_DocumentReference(src.XY, src.LG);
});
$p.ak = (function(src) {
  return this.bwP(src);
});
var $d_Lapp_data_DocumentReferenceWithVersion$$anon$4 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_DocumentReferenceWithVersion$$anon$4, "app.data.DocumentReferenceWithVersion$$anon$4", ({
  Dh: 1,
  V: 1,
  U: 1
}));
export { $d_Lapp_data_DocumentReferenceWithVersion$$anon$4 as $d_Lapp_data_DocumentReferenceWithVersion$$anon$4 };
//# sourceMappingURL=app.data.-Document-Reference-With-Version$$anon$4.js.map
